import * as React from 'react';

const HandShakeIcon = (props) => (
  <svg
    id='Layer_1'
    viewBox='0 0 104 104'
    {...props}
    xmlns='http://www.w3.org/2000/svg'
    data-name='Layer 1'
  >
    <path
      fill={'currentColor'}
      d='m54.52 40.58c-4.74.67-8.88 5.12-8.92 5.16a1 1 0 0 1 -.2.16c-6.44 4.18-10.07 1-10.22.81-4.12-3.71-.34-9.93-.18-10.19a37.93 37.93 0 0 1 6.08-7.66h-17.49l-7.59 25.04a.92.92 0 0 1 .22.17c11.78 13.32 27.42 25.14 33.59 29.6a3.15 3.15 0 0 0 4.07-4.79l-8.49-8.49a1 1 0 0 1 0-1.41 1 1 0 0 1 1.42 0l4.52 4.52 4 4 2 2.05a3.83 3.83 0 0 0 5.46-5.37l-7.79-8.13-1.48-1.53a1 1 0 0 1 0-1.42 1 1 0 0 1 1.42 0l11.37 11.8a4 4 0 0 0 6.81-2.67 3.89 3.89 0 0 0 -1.2-2.93l-6.82-6.6-4.75-4.61a1 1 0 1 1 1.39-1.43l13.5 13.07a3.76 3.76 0 1 0 5.15-5.47z'
    />
    <path
      fill={'currentColor'}
      d='m20.54 23a36.92 36.92 0 0 0 -16.54-3.22v39.22h6.11a3 3 0 0 0 2.89-2.17l9.18-30.23a3 3 0 0 0 -1.64-3.6z'
    />
    <path
      fill={'currentColor'}
      d='m57.76 24.94a9.39 9.39 0 0 0 -6.76-.15c-3.83 1.4-9.42 4.76-14.33 12.78 0 .06-3.07 5-.18 7.66.1.09 2.68 2.25 7.68-.94.72-.75 5.23-5.27 10.56-5.76a1 1 0 0 1 .76.26l26.21 24c.12.11.23.23.34.35 3-.46 5-3.2 5.58-4.2l-9.5-25.89z'
    />
    <path
      fill={'currentColor'}
      d='m98 24.55a44.21 44.21 0 0 0 -16.66 3.14 3 3 0 0 0 -1.62 3.83l11.13 30.29a3.07 3.07 0 0 0 2.86 2h6.29v-39.21c-.5-.03-1.19-.05-2-.05z'
    />
  </svg>
);

export default HandShakeIcon;
